"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingHeader = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _framerMotion = require("framer-motion");
var _react2 = _interopRequireDefault(require("react"));
var _TableHeader = require("../TableHeader");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FloatingHeader = _ref => {
  var {
    currentDates,
    sortedByDate,
    handleDateSort,
    handleScrollLeft,
    handleScrollRight,
    isScrollLeftDisabled,
    isScrollRightDisabled = false,
    isLoading = false,
    isMobile,
    isSmallerThanSm,
    handleSortToggle,
    getColumnWidth,
    locale = 'en-GB'
  } = _ref;
  return (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
    initial: {
      opacity: 0,
      y: -20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -20
    },
    style: styles.motionContainer,
    "data-testid": "hotel-price-table-floating-header",
    children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.outerContainer), {}, {
      children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.innerContainer), {}, {
        children: (0, _jsxRuntime.jsxs)(_react.Table, _objectSpread(_objectSpread({}, styles.table), {}, {
          style: {
            tableLayout: 'fixed',
            minWidth: isMobile ? '280px' : 'auto'
          },
          children: [(0, _jsxRuntime.jsxs)("colgroup", {
            children: [!isMobile && (0, _jsxRuntime.jsx)("col", {
              style: styles.hotelNameCol
            }), (0, _jsxRuntime.jsx)("col", {
              style: {
                width: isMobile ? '24px' : '40px'
              }
            }), currentDates.map((_, idx) => (0, _jsxRuntime.jsx)("col", {
              style: {
                width: getColumnWidth()
              }
            }, idx)), (0, _jsxRuntime.jsx)("col", {
              style: {
                width: isMobile ? '24px' : '40px'
              }
            })]
          }), (0, _jsxRuntime.jsx)(_TableHeader.TableHeader, {
            currentDates: currentDates,
            sortedByDate: sortedByDate,
            handleDateSort: handleDateSort,
            handleScrollLeft: handleScrollLeft,
            handleScrollRight: handleScrollRight,
            isScrollLeftDisabled: isScrollLeftDisabled,
            isScrollRightDisabled: isScrollRightDisabled,
            isLoading: isLoading,
            isMobile: isMobile,
            isSmallerThanSm: isSmallerThanSm,
            handleSortToggle: handleSortToggle,
            locale: locale
          })]
        }))
      }))
    }))
  });
};
exports.FloatingHeader = FloatingHeader;
var styles = {
  motionContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 100,
    background: _constants.THEME_COLORS.floatingHeaderBg,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    padding: 0,
    backdropFilter: 'blur(8px)'
  },
  outerContainer: {
    maxW: {
      base: '100%',
      xs: '100%',
      sm: 'calc(100% - 30px)',
      md: 'calc(100% - 40px)',
      lg: 'calc(100% - 100px)',
      xl: '1217px'
    },
    mx: 'auto',
    px: 0
  },
  innerContainer: {
    w: '100%',
    mx: 'auto',
    px: {
      base: 0,
      md: 4,
      xl: 0
    }
  },
  table: {
    variant: 'simple',
    size: 'sm',
    role: 'presentation'
  },
  hotelNameCol: {
    width: '50%'
  }
};